module.exports = __webpack_public_path__ + "img/logo_starbucks1.258cd030.png";